import { Query } from 'apollo-angular';
import { Injectable } from '@angular/core';
import gql from 'graphql-tag';

// Model
import { PD } from '../models/PD';

@Injectable({
  providedIn: 'root'
})
export class UpQuery extends Query<PD, {}> {
  document = gql`
    query upQuery($friendlyId: String) {
      pDs(where: { friendlyId: $friendlyId }) {
        friendlyId
        nombre
        heroDescription
        descripProductoWeb
        heroImg {
          url
        }
        heroRImg {
          url
        }
        imagenProductoWeb {
          url
        }
        imagenProductoWebResponsive {
          url
        }
        beneficios {
          titulo: tituloPublico
          descripcion
          displayIndex
          icono {
            url
          }
        }
        tyC {
          url
        }
      }
    }
  `;
}
